import { render } from "./backlog.vue?vue&type=template&id=4007aa34&scoped=true"
import script from "./backlog.vue?vue&type=script&lang=js"
export * from "./backlog.vue?vue&type=script&lang=js"

import "./backlog.vue?vue&type=style&index=0&id=4007aa34&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4007aa34"]])

export default __exports__